module.exports = "/_next/static/images/528d8da3ace1ba4246254d0d634c9a94-man-holding-device-2@1x.jpg.webp";